import {useMemo} from 'react';
import type {TableConfiguration} from 'schema/table/types';
import type {NationalAgentType} from 'services/agent/types';
import type {NationalAgentWithInEbba} from '../types';
import {TrueAsVerifiedIcon} from '../../../schemas/renderers';
import {useNationalAgentsTableColumns} from './useNationalAgentsTableColumns';

export const useNationalAgentsResultTableConfig = (
  agentType: NationalAgentType,
): TableConfiguration<NationalAgentWithInEbba> => {
  const defaultColumns = useNationalAgentsTableColumns(agentType);

  return useMemo(() => {
    const config: TableConfiguration<NationalAgentWithInEbba> = {
      titleVariant: 'noHeaderAndSelectorEmbedded',
      defaultColumns,
      enableSelectionButton: 'single',
      partValueRenderers: {
        inEbba: TrueAsVerifiedIcon,
      },
    };

    return config;
  }, [defaultColumns]);
};
